<template>
  <div>
    <nuxt></nuxt>
  </div>
</template>

<script>
export default {
  mounted() {
    const lang = window?.navigator?.language?.split('-')?.[0] ?? 'es'
    const switchLocalePath = this.switchLocalePath(lang)

    // eslint-disable-next-line no-console
    console.log('🌍 LAYOUT: Verificando redirección de locale')
    // eslint-disable-next-line no-console
    console.log('  - lang:', lang)
    // eslint-disable-next-line no-console
    console.log('  - switchLocalePath:', switchLocalePath)
    // eslint-disable-next-line no-console
    console.log('  - window.location.pathname:', window.location.pathname)

    if (!switchLocalePath) {
      // eslint-disable-next-line no-console
      console.log('  ✅ switchLocalePath vacío, no se redirige')
      return
    }

    // Normalizar paths para evitar loop infinito:
    // - stripear query params (switchLocalePath puede incluir ?id=xxx)
    // - stripear trailing slash (/compra/ vs /compra)
    const normalizePath = (path) =>
      (path || '').split('?')[0].replace(/\/$/, '') || '/'
    const currentNormalized = normalizePath(window.location.pathname)
    const targetNormalized = normalizePath(switchLocalePath)

    // eslint-disable-next-line no-console
    console.log('  - currentNormalized:', currentNormalized)
    // eslint-disable-next-line no-console
    console.log('  - targetNormalized:', targetNormalized)

    if (currentNormalized !== targetNormalized) {
      // eslint-disable-next-line no-console
      console.log('  ⚠️  Redirigiendo a:', switchLocalePath)
      window.location.href = switchLocalePath
    } else {
      // eslint-disable-next-line no-console
      console.log('  ✅ No se necesita redirección')
    }
  }
}
</script>
